import React from "react"
import TitleSubtitleSwitch from "../../../TitleSubtitleSwitch/index"
import { Box, Typography } from "@material-ui/core"
import PropTypes from "prop-types"

const EstimateDeposit = ({
  toggleDepositRequired = () => {},
  depositRequired = false,
  loading = false,
  switchDisabled = false,
}) => {
  return (
    <Box display="flex" flexDirection="column" padding="10px">
      <Typography
        variant="body1"
        style={{
          fontSize: "18px",
          fontWeight: 600,
          marginBottom: "25px",
          textAlign: "left",
        }}
      >
        If deposit is required:
      </Typography>

      <TitleSubtitleSwitch
        titleText="Enable Deposit"
        subtitleText="This client is required to pay 50% of estimate to move the shoot forward"
        setterFn={toggleDepositRequired}
        stateVar={depositRequired}
        loading={loading}
        disabled={switchDisabled}
      />
    </Box>
  )
}

EstimateDeposit.propTypes = {
  toggleDepositRequired: PropTypes.func,
  depositRequired: PropTypes.bool,
  loading: PropTypes.bool,
  switchDisabled: PropTypes.bool,
}

export default EstimateDeposit
